import { createContext, useContext, useState, useCallback } from "react";

const ServiceContext = createContext();

export const useService = () => useContext(ServiceContext);

const SERVICES = {
  ground: { id: "ground", label: "PCP/ACP-G", available: true },
  sfa_emr: { id: "sfa_emr", label: "SFA/EMR", available: true },
  wes: { id: "wes", label: "PCP-PS", available: true },
  air_ambulance: {
    id: "air_ambulance",
    label: "Air Ambulance",
    available: true,
    subServices: {
      air_adult: { id: "air_adult", label: "Adult", available: true },
      air_pediatric: { id: "air_pediatric", label: "OB/NEO/PEDS", available: true },
    },
  },
};

// Flat list of all selectable service IDs (for filtering)
const SELECTABLE_SERVICES = ["ground", "sfa_emr", "wes", "air_adult", "air_pediatric"];

export const ServiceProvider = ({ children }) => {
  const [activeService, setActiveService] = useState(() => {
    try {
      return localStorage.getItem("yems-service") || "ground";
    } catch {
      return "ground";
    }
  });

  const switchService = useCallback((service) => {
    if (!SELECTABLE_SERVICES.includes(service)) return;
    setActiveService(service);
    try {
      localStorage.setItem("yems-service", service);
    } catch {}
  }, []);

  return (
    <ServiceContext.Provider value={{ activeService, switchService, SERVICES }}>
      {children}
    </ServiceContext.Provider>
  );
};
